import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { EmployeePositionId } from '../../../classes/models/employee/Employee';
import { TemporaryPreferredTimeOff } from '../../../classes/models/employee/TemporaryPreferredTimeOff';
import {
  AddEmployeeOneTimePreferredTimeOffRequest,
  EditEmployeeOneTimePreferredTimeOffRequest
} from '../../../interfaces/request/EmployeeRequests';

/**
 * This service communicates with backend to handle employee one time preferred time off data management.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeeOneTimePreferredTimeOffService {
  private http = inject(HttpClient);

  url = environment.apiUrl + '/employees';

  /**
   * Adds a one time preferred time off to the employee.
   * @param id identifiers of employee and position.
   * @param preferredTimeOff a new one time preferred time off to add.
   */
  addOneTimePreferredTimeOff(id: EmployeePositionId, preferredTimeOff: TemporaryPreferredTimeOff) {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/one-time-preferred-times-off`;
    const requestBody: AddEmployeeOneTimePreferredTimeOffRequest = {
      reason: preferredTimeOff.reason,
      date: preferredTimeOff.date,
      startTime: preferredTimeOff.startTime,
      endTime: preferredTimeOff.endTime
    };
    return this.http.post(url, requestBody);
  }

  /**
   * Edits one time preferred time off for the given employee.
   * @param id identifiers of employee and position.
   * @param preferredTimeOff a preferred time off to be edited.
   */
  editOneTimePreferredTimeOff(id: EmployeePositionId, preferredTimeOff: TemporaryPreferredTimeOff) {
    const url =
      `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/one-time-preferred-times-off/${preferredTimeOff.date}`;
    const requestBody: EditEmployeeOneTimePreferredTimeOffRequest = {
      reason: preferredTimeOff.reason,
      startTime: preferredTimeOff.startTime,
      endTime: preferredTimeOff.endTime
    };
    return this.http.put(url, requestBody);
  }

  /**
   * Deletes a one time preferred time off.
   * @param id identifiers of employee and position.
   * @param date start date of preferred time off.
   */
  deleteOneTimePreferredTimeOff(id: EmployeePositionId, date: string) {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/one-time-preferred-times-off/${date}`;
    return this.http.delete(url);
  }
}
